import { Route, Routes } from "react-router-dom";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { CategoryPage } from "@/pages/CategoryPage";
import { HomePage } from "@/pages/HomePage";
import { ProductPage } from "@/pages/ProductPage";
import { SearchPage } from "@/pages/SearchPage";

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route index element={<HomePage />} />
        <Route path="category/:categorySlug" element={<CategoryPage />} />
        <Route path="category/:categorySlug/:brandSlug" element={<CategoryPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="product/:productSlug" element={<ProductPage />} />
      </Route>
    </Routes>
  );
}
